import React from "react";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { formatMinutes } from "../../../../app/datetimeUtils";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { AssignedTutorialUsage, TutorialUsageByCategory } from "./UsageFilteredByCourseViewModel";

export function AssignedLessonUsageTable(props: {
	className?: string;
	assignedTutorialUsageForCourse: AssignedTutorialUsage[];
	assignedLessonTimeMinutes: number;
}) {
	const timeSpentBodyTemplate = (rowData: TutorialUsageByCategory) => {
		return formatMinutes(rowData.timeSpentMinutes);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Total Time" colSpan={2} footerClassName="font-medium !text-right" />
				<Column
					footer={formatMinutes(props.assignedLessonTimeMinutes)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	const hasData =
		props.assignedTutorialUsageForCourse && props.assignedTutorialUsageForCourse.length > 0;

	return (
		<DataTable
			value={props.assignedTutorialUsageForCourse}
			dataKey="tutorialId"
			loading={props.assignedTutorialUsageForCourse == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column header="Lesson" field="tutorialName" sortable></Column>
			<Column header="Number of Assigned Students" field="studentsAssigned" sortable></Column>
			<Column
				header="Total Time Spent"
				body={timeSpentBodyTemplate}
				sortable
				sortField="timeSpentMinutes"></Column>
		</DataTable>
	);
}
